var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "orders-table" },
    [
      _c(
        "vue-good-table",
        {
          ref: "table",
          attrs: {
            id: "product-table",
            columns: _vm.columns,
            rows: _vm.orders,
            "search-options": {
              enabled: true,
              trigger: "enter",
              skipDiacritics: true,
              placeholder: "Search this table"
            },
            "pagination-options": {
              enabled: true,
              mode: "pages",
              perPage: 10
            }
          }
        },
        [
          _c(
            "div",
            { attrs: { slot: "table-actions" }, slot: "table-actions" },
            [
              _c(
                "button",
                {
                  staticClass: "export",
                  on: {
                    click: function($event) {
                      return _vm.exportXLSX()
                    }
                  }
                },
                [
                  _c("svg", { attrs: { viewBox: "0 0 384 512" } }, [
                    _c("path", {
                      attrs: {
                        d:
                          "M369.9 97.98L286.02 14.1c-9-9-21.2-14.1-33.89-14.1H47.99C21.5.1 0 21.6 0 48.09v415.92C0 490.5 21.5 512 47.99 512h288.02c26.49 0 47.99-21.5 47.99-47.99V131.97c0-12.69-5.1-24.99-14.1-33.99zM256.03 32.59c2.8.7 5.3 2.1 7.4 4.2l83.88 83.88c2.1 2.1 3.5 4.6 4.2 7.4h-95.48V32.59zm95.98 431.42c0 8.8-7.2 16-16 16H47.99c-8.8 0-16-7.2-16-16V48.09c0-8.8 7.2-16.09 16-16.09h176.04v104.07c0 13.3 10.7 23.93 24 23.93h103.98v304.01zM64 208v224c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16zm224 208h-80v-48h80v48zm0-80h-80v-48h80v48zM96 224h192v32H96v-32zm0 64h80v48H96v-48zm0 80h80v48H96v-48z"
                      }
                    })
                  ])
                ]
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }